import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/location/muzaffarnagar")({
  beforeLoad: () => {
    throw redirect({ to: "/locations/muzaffarnagar", replace: true, statusCode: 301 });
  },
});